// React
import { useMemo } from 'react';

// Components
import TemplateBody from 'components/TemplatePreview/TemplateBody';

import { generateTemplateHashes } from 'components/TaskChecklist/utils';

export const PreviewChecklistBody = ({ checklist }: any) => {
  const items = useMemo(() => {
    const checklistItems = checklist?.ChecklistItems || [];
    return checklistItems;
  }, [checklist?.ChecklistItems]);

  const checklistHash = useMemo(() => {
    return generateTemplateHashes(checklist?.ChecklistItems, 'id') || null;
  }, [checklist?.ChecklistItems]);

  return (
    <>
      <TemplateBody checklistHash={checklistHash} checklistItems={items} />
    </>
  );
};
